var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "title_sp" }, [_c("custom-breadcrumb")], 1),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-header" },
      [
        _c(
          "div",
          { staticClass: "search-box" },
          [
            _c(
              "el-select",
              {
                staticClass: "search-select",
                attrs: { clearable: "", placeholder: "Store Type" },
                model: {
                  value: _vm.selectData.storeType,
                  callback: function($$v) {
                    _vm.$set(_vm.selectData, "storeType", $$v)
                  },
                  expression: "selectData.storeType"
                }
              },
              _vm._l(_vm.storeTypeMap, function(item, index) {
                return _c("el-option", {
                  key: item.textTitle,
                  attrs: { label: item.textTitle, value: index }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "date-picker", staticStyle: { display: "flex" } },
          [
            _c(
              "div",
              {
                staticClass: "date-picker-title",
                staticStyle: { display: "flex" }
              },
              [_vm._v("Most Recent Login")]
            ),
            _vm._v(" "),
            _c("el-date-picker", {
              staticClass: "el-date-picker",
              attrs: {
                type: "daterange",
                "prefix-icon": "default-icon",
                "start-placeholder": "start date",
                "end-placeholder": "end date",
                "value-format": "yyyy-MM-dd"
              },
              model: {
                value: _vm.selectTime,
                callback: function($$v) {
                  _vm.selectTime = $$v
                },
                expression: "selectTime"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-input" },
          [
            _c("el-input", {
              staticClass: "search-bar",
              attrs: {
                "prefix-icon": "el-icon-search",
                placeholder: "Search Store name, Contact name"
              },
              model: {
                value: _vm.selectData.keyWords,
                callback: function($$v) {
                  _vm.$set(_vm.selectData, "keyWords", $$v)
                },
                expression: "selectData.keyWords"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "search-btn",
            attrs: { type: "primary" },
            on: { click: _vm.searchButton }
          },
          [_vm._v("Search")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-table",
          {
            staticClass: "customer-table",
            attrs: {
              data: _vm.tableData,
              stripe: "",
              "empty-text": "No customers available",
              "show-empty": false
            }
          },
          [
            _c("el-table-column", {
              attrs: { prop: "storeName", label: "Store Name", width: "250" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("p", { staticClass: "customer-store-name" }, [
                        _vm._v(_vm._s(scope.row.storeName))
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "storeType", label: "Store types", width: "250" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n    " +
                          _vm._s(
                            scope.row.storeType === null ||
                              scope.row.storeType === undefined
                              ? "--"
                              : scope.row.storeType
                          ) +
                          "\n  "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "fullName", label: "Contact name", width: "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n    " +
                          _vm._s(
                            scope.row.fullName === null ||
                              scope.row.fullName === undefined
                              ? "--"
                              : scope.row.fullName
                          ) +
                          "\n  "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "itemInCart",
                label: "Item in cart",
                width: "200"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n    " +
                          _vm._s(
                            scope.row.itemInCart === null ||
                              scope.row.itemInCart === undefined
                              ? "--"
                              : scope.row.itemInCart
                          ) +
                          "\n  "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "lastLoginTime",
                label: "Most Recent Login",
                width: "200"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n    " +
                          _vm._s(
                            scope.row.lastLoginTime === null ||
                              scope.row.lastLoginTime === undefined
                              ? "--"
                              : scope.row.lastLoginTime
                          ) +
                          "\n  "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "location",
                label: "Location",
                "min-width": "400"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("div", { staticClass: "location-col" }, [
                        scope.row.location != "--"
                          ? _c("img", {
                              attrs: {
                                src: require("../../assets/img/gmap-location.png")
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "ellipsis" }, [
                          _vm._v(_vm._s(scope.row.location))
                        ])
                      ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("Pagination", {
          attrs: {
            currentPage: _vm.paging.current,
            total: _vm.paging.total,
            pageSize: _vm.paging.size
          },
          on: {
            handleSizeChange: _vm.handleSizeChange,
            handleCurrentChange: _vm.handleCurrentChange
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed27e478", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed27e478","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/customer/opportunities.vue
// module id = 8W7T
// module chunks = 2